import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { profileMenu } from './blocks';

const Header = ({ children, className, ...otherProps }) => (
  <div className={clsx(profileMenu('header'), className)} {...otherProps}>
    {children}
  </div>
);

Header.propTypes = {
  /**
   * Children nodes of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  className: PropTypes.string
};

Header.defaultProps = {
  children: null,
  className: null
};

Header.displayName = 'ProfileMenu.Header';

export default Header;
